// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__PJztr","container":"SectionFaq_container__ryQvV","faq__title":"SectionFaq_faq__title__SMArH","faq__list-container":"SectionFaq_faq__list-container__uFixp"};